import { render, staticRenderFns } from "./duration-picker.vue?vue&type=template&id=3b047c4c"
import script from "./duration-picker.vue?vue&type=script&lang=js"
export * from "./duration-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports